export default "__VITE_ASSET__DLdDEfrh__"